import TabsList from "./tabs-list/tabs-list";

export default class Tabs {
  /**
   * @param {HTMLElement} element
   */
  constructor(element) {
    this.element = element;
    this.elements = {
      tabpanels: Array.from(this.element.querySelectorAll(".Tabs-tabpanel")),
    };
    this.state = {
      active: 0,
    };

    this.TabsList = new TabsList(this.element, this);

    this.element.dataset.js = true;
  }

  /**
   * @param {number} activeTab
   */
  setActiveTab(activeTab) {
    this.state.active = activeTab;

    this._render();
  }

  /**
   * @returns {void}
   */
  _render() {
    this.elements.tabpanels.forEach((tabpanel, i) => {
      /* eslint-disable-next-line no-param-reassign */
      tabpanel.hidden = i !== this.state.active;
    });

    this.TabsList.render();
  }
}

document.querySelectorAll(".js-Tabs").forEach((element) => new Tabs(element));
